import { ConfigTypes } from '../../components/templates/models/config-types.enum';

export const getTemplateEventColor = (title) => {
  const name = title?.toLowerCase();

  //  TODO: handle all types: specialty exam,  exam, office use only, texam / cl, special testing, dispense / repair.
  switch (name) {
    case ConfigTypes.RcOv:
      return '#E53935';
    case ConfigTypes.Flex:
      return '#87959F';
    case ConfigTypes.TExam:
      return '#f799f2ff';
    case ConfigTypes.TExamCL:
      return '#AEC8DA';
    case ConfigTypes.Lunch:
      return '#DFD836';
    case ConfigTypes.Exam:
      return '#DDE4EE';
    case ConfigTypes.OfficeUseOnly:
      return '#fadea2ff';
    case ConfigTypes.DispenseRepair:
      return '#e3f3bfff';
    default:
      return '#79CEF1';
  }
};
